import type { HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';
import { useRouteLoaderData } from '@remix-run/react';

import StaticPage from '~/components/StaticPage';
import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { RootLoaderData } from '~/root';
import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import { BASE_CACHE_TAG } from '~/utils/setCacheHeaders/index.server';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import type { StaticPageLoaderData } from '../../services/static_page';
import { staticPageLoader } from '../../services/static_page';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': loaderHeaders.get('Cache-Tag') || BASE_CACHE_TAG,
  };
};

export const meta: MetaFunction<typeof staticPageLoader> = getStaticPageMetaData;
export const loader: LoaderFunction = async ({ request, context }) => {
  return staticPageLoader({
    request,
    context,
    pageRequestParams: {
      pathname: 'authors',
    },
  });
};

export const clientLoader = staticPageClientLoader;

const Authors = () => {
  const { page } = useTypedLoaderData<StaticPageLoaderData>();
  const { site } = useRouteLoaderData('root') as RootLoaderData;

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default Authors;
